import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { createOrUpdateProfileDetails } from "../api/api";
import "../UpdateProfileDetails/UpdateProfileDetails.css";
import RegistraionFlowHeader from "../RegistraionFlowHeader/RegistraionFlowHeader";
import bgImage from "../../assets/images/brown-background.jpg";

const options = {
  relationship_status: [
    "Divorced",
    "Domestic Partnership",
    "Separated",
    "Single",
    "Unknown/Prefer Not to Say",
    "Widowed",
    "Other",
    "Prefer not to say",
  ],
  ethnicity: [
    "Asian",
    "Black",
    "Caucasian",
    "Hispanic",
    "Other",
    "Prefer not to say",
  ],
  religion: ["Christianity", "Islam", "Other", "Prefer not to say"],
  occupation: [
    "Accountant",
    "Actor",
    "Administrative Assistant",
    "Architect",
    "Artist",
    "Business Owner",
    "Chef",
    "Consultant",
    "Designer",
    "Doctor",
    "Engineer",
    "Entrepreneur",
    "Finance Professional",
    "Firefighter",
    "Freelancer",
    "Homemaker",
    "Lawyer",
    "Marketing Specialist",
    "Mechanic",
    "Military Personnel",
    "Musician",
    "Nurse",
    "Pharmacist",
    "Police Officer",
    "Real Estate Agent",
    "Retired",
    "Salesperson",
    "Scientist",
    "Software Developer",
    "Student",
    "Teacher",
    "Unemployed",
    "Writer",
    "Other",
    "Prefer not to say",
  ],
  blood_group: [
    "AA (Normal)",
    "AS (Carrier)",
    "SS (Sickle Cell Disease)",
    "AC",
    "SC",
    "CC",
    "Prefer not to say",
  ],
  have_children: ["Yes", "No"],
  want_children: ["Yes", "No"],
  height: [
    "< 150 cm",
    "150 - 155 cm",
    "156 - 160 cm",
    "161 - 165 cm",
    "166 - 170 cm",
    "171 - 175 cm",
    "176 - 180 cm",
    "181 - 185 cm",
    "186 - 190 cm",
    "> 190 cm",
  ],
  body_type: [
    "Athletic",
    "Average",
    "Curvy",
    "Slim",
    "Other",
    "Prefer not to say",
  ],
  hair_color: ["Black", "Blonde", "Brown", "Red", "Other", "Prefer not to say"],
  language_spoken: [
    "Arabic",
    "Bengali",
    "English",
    "French",
    "German",
    "Gujarati",
    "Hindi",
    "Italian",
    "Japanese",
    "Javanese",
    "Korean",
    "Malay/Indonesian",
    "Mandarin Chinese",
    "Marathi",
    "Persian (Farsi)",
    "Portuguese",
    "Punjabi",
    "Russian",
    "Spanish",
    "Swahili",
    "Tamil",
    "Telugu",
    "Turkish",
    "Urdu",
    "Vietnamese",
    "Other",
    "Prefer not to say",
  ],
  political_affiliation: [
    "Conservative",
    "Liberal",
    "Moderate",
    "Other",
    "Prefer not to say",
  ],
  smokes: ["Yes", "No"],
  drinks: ["Yes", "No"],
  have_pets: ["Yes", "No"],
  have_pet_allergies: ["Yes", "No"],
  preferred_game_genere: [
    "Action",
    "Adventure",
    "Arcade",
    "Battle Royale",
    "Card & Board",
    "Casual",
    "Fighting",
    "Idle / Clicker",
    "Multiplayer",
    "Platformer",
    "Puzzle",
    "Racing",
    "Role-Playing (RPG)",
    "Shooter",
    "Simulation",
    "Sports",
    "Strategy",
    "Survival",
    "Trivia / Quiz",
    "Other",
    "Prefer not to say",
  ],
  education_level: [
    "High School",
    "Bachelor's",
    "Master's",
    "PhD",
    "Other",
    "Prefer not to say",
  ],
  cultural_background: [
    "Asian",
    "African",
    "European",
    "Indigenous",
    "Other",
    "Prefer not to say",
  ],
  // income: ["< $30", "$30 - $60", "$60 - $100", "> $100"],
};

const labels = {
  relationship_status: "Select relationship status",
  ethnicity: "Select ethnicity",
  religion: "Select religion",
  occupation: "Select Occupation",
  blood_group: "Select blood group genotype",
  have_children: "Do you have children?",
  want_children: "Do you want children?",
  height: "Select Height",
  body_type: "Select body type",
  hair_color: "Select hair color",
  language_spoken: "Select languages spoken (Select up to 4)",
  political_affiliation: "Select political affiliation",
  smokes: "Do you smoke?",
  drinks: "Do you drink?",
  have_pets: "Do you have pets?",
  have_pet_allergies: "Do you have pet allergies?",
  preferred_game_genere: "Select Preferred Game Genres (Select up to 5)",
  education_level: "Select education level",
  cultural_background: "Cultural Background",
  // income: "Enter Income",
};

const validationSchema = Yup.object().shape({
  relationship_status: Yup.string().required("Relationship status is Required"),
  ethnicity: Yup.string().required("Ethnicity is Required"),
  religion: Yup.string().required("Religion is Required"),
  occupation: Yup.string().required("Occupation is Required"),
  blood_group: Yup.string().required("Blood Group is Required"),
  have_children: Yup.string().required("Please specify if you have children"),
  want_children: Yup.string().required("Please specify if you want children"),
  height: Yup.string().required("Height is Required"),
  body_type: Yup.string().required("Body type is Required"),
  hair_color: Yup.string().required("Hair Color is Required"),
  language_spoken: Yup.array()
    .min(1, "Select at least 1")
    .max(4, "You can select up to 4 languages")
    .required("Language is Required"),
  political_affiliation: Yup.string().required(
    "Political Affiliation is Required"
  ),
  smokes: Yup.string().required("Please select if you Smoke"),
  drinks: Yup.string().required("Please select if you Drink"),
  have_pets: Yup.string().required("Please select if you have pets"),
  have_pet_allergies: Yup.string().required("Please select pet allergy status"),
  preferred_game_genere: Yup.array()
    .min(1, "Select at least one genre")
    .max(5, "You can select up to 5 genres")
    .required("Please select at least one genre"),
  // income: Yup.string().required("Income is Required"),
  education_level: Yup.string().required("Education level is Required"),
  cultural_background: Yup.string().required("Cultural Background is Required"),
});

const UpdateProfileDetails = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: Object.fromEntries(
      Object.keys(options).map((key) => [
        key,
        key === "language_spoken" || key === "preferred_game_genere" ? [] : "",
      ])
    ),
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const userData = JSON.parse(localStorage.getItem("currentUser"));
      const userId = userData?.id || userData?._id;

      const payload = {
        user_id: userId,
        profile_completion_status: "Lovelanguage",
        ...values,
      };

      try {
        const response = await createOrUpdateProfileDetails(payload);
        if (response?.success) navigate("/Lovelanguage");
        else alert(response.message);
      } catch (err) {
        console.error(err);
        alert("Something went wrong!");
      } finally {
        setLoading(false);
      }
    },
  });

  const renderDropdown = (key, items) => (
    <div className="updateform-group" key={key}>
      <label className="updateform-label">{labels[key]}</label>
      <select
        name={key}
        value={formik.values[key]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        className="updateform-control"
      >
        <option value="">Select</option>
        {items.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>
      {formik.touched[key] && formik.errors[key] && (
        <div className="updateform-error">{formik.errors[key]}</div>
      )}
    </div>
  );

  return (
    <div
      className="updateprofile-container sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="containerall">
        <RegistraionFlowHeader />
        <div className="updateprofile-field">
          <h2 className="updateform-title">Update Profile Details</h2>
          <form onSubmit={formik.handleSubmit} className="updateprofile-form">
            {Object.entries(options).map(([key, items]) => {
              if (
                key === "language_spoken" ||
                key === "preferred_game_genere"
              ) {
                return (
                  <div className="updateform-group" key={key}>
                    <label className="updateform-label">{labels[key]}</label>
                    <Select
                      isMulti
                      name={key}
                      options={items.map((val) => ({ label: val, value: val }))}
                      value={formik.values[key].map((val) => ({
                        label: val,
                        value: val,
                      }))}
                      onChange={(selected) => {
                        const limit = key === "language_spoken" ? 4 : 5;
                        if (selected.length <= limit) {
                          formik.setFieldValue(
                            key,
                            selected.map((sel) => sel.value)
                          );
                        }
                      }}
                      isOptionDisabled={(option) =>
                        formik.values[key].length >=
                          (key === "language_spoken" ? 4 : 5) &&
                        !formik.values[key].includes(option.value)
                      }
                      onBlur={() => formik.setFieldTouched(key, true)}
                      placeholder="Select"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderRadius: 30,
                          borderColor: state.isFocused ? "#2684FF" : "#ccc",
                          boxShadow: state.isFocused
                            ? "0 0 0 1px #2684FF"
                            : "none",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          borderRadius: 30,
                        }),
                        multiValueLabel: (base) => ({
                          ...base,
                          color: "#000",
                          fontWeight: "600",
                        }),
                        multiValueRemove: (base) => ({
                          ...base,
                          borderRadius: 30,
                          ":hover": { backgroundColor: "red", color: "white" },
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: "#000",
                          fontWeight: "500",
                          fontSize: 15,
                          paddingLeft: 10,
                        }),
                      }}
                    />
                    {formik.touched[key] && formik.errors[key] && (
                      <div className="updateform-error">
                        {formik.errors[key]}
                      </div>
                    )}
                  </div>
                );
              }

              // if (key === "income") {
              //   return (
              //     <div className="updateform-group" key={key}>
              //       <label className="updateform-label">{labels[key]}</label>
              //       <textarea
              //         rows={2}
              //         className="updateform-control"
              //         name={key}
              //         value={formik.values[key]}
              //         onChange={formik.handleChange}
              //         onBlur={formik.handleBlur}
              //       />
              //       {formik.touched[key] && formik.errors[key] && (
              //         <div className="updateform-error">{formik.errors[key]}</div>
              //       )}
              //     </div>
              //   );
              // }

              return renderDropdown(key, items);
            })}
            <button
              type="submit"
              disabled={loading}
              className="updatesubmit-btn"
            >
              {loading ? "Submitting..." : "Continue"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfileDetails;
